import { useEffect, useMemo } from 'react'

import { InputGroup, InputGroupText, Input } from 'twyne-new.ui'

import { parseGradient, useCraftProp } from '@/components/builder/utils'
import TailwindSandbox from '@/modules/cms/views/post/components/builder/Content/TailwindSandbox'

const GradientPreview = ({ gradient = {}, name }) => {
  const { setValue: setCraftValue } = useCraftProp(name)

  const gradientClass = `bg-[${parseGradient(gradient)}]`
  const inputValue = useMemo(() => {
    if (gradient?.direction) {
      return ''
    }

    const colors = gradient?.colors?.filter(item => item?.color).map(({ color }) => color?.hex || color)
    if (!colors?.length) {
      return 'Gradient'
    }

    const args = [
      gradient?.linear?.degrees && `${gradient?.linear?.degrees}deg`,
      gradient?.linear?.direction,
      gradient?.radial?.shape,
      gradient?.radial?.size,
    ].filter(Boolean)
    const gradientText = [gradient?.type, colors, args].filter(Boolean).join(', ')
    return gradientText || 'Gradient'
  }, [gradient])

  useEffect(() => {
    if (gradient.direction) {
      const linear = { direction: gradient.direction }
      const colors = gradient.colors.map((color, index) => ({ color, value: getGradientColorValue(gradient?.colors?.length, index) }))
      setCraftValue({ linear, colors, type: 'linear' })
    }
  })

  return <>
    <div className='flex items-center'>
      <InputGroup>
        <InputGroupText addonType={null}>
          <TailwindSandbox className='w-4 h-4' htmlClassName='w-4 h-4 bg-transparent!' bodyClassName='w-4 h-4 bg-transparent!'>
            <div className={`w-4 h-4 rounded-xs ${gradientClass}`} />
          </TailwindSandbox>
        </InputGroupText>
      </InputGroup>
      <Input className='text-left' value={inputValue} readOnly variant='accent' />
    </div>
  </>
}

export const getGradientColorValue = (colorsLength, index) => (index / (colorsLength - 1)) * 100 || 1

export default GradientPreview
